import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=346e4f50"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346e4f50')) {
      api.createRecord('346e4f50', component.options)
    } else {
      api.reload('346e4f50', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=346e4f50", function () {
      api.rerender('346e4f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/views/Loading.vue"
export default component.exports